export default __webpack_public_path__ + "static/media/hdmail .345b0c57.svg";